/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ApiCredentials {
  /**
  * API client ID.
  */
  'clientId': string;
  /**
  * API client secret.
  */
  'clientSecret': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "clientId",
      "baseName": "clientId",
      "type": "string",
      "format": ""
    },
    {
      "name": "clientSecret",
      "baseName": "clientSecret",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ApiCredentials.attributeTypeMap;
  }

  public constructor() {
  }
}

